export const environment = {
  _ssp: 'M#0AygZi36C9*EcPxNATUsB^V9WlZmUQJ^FrrJ$tUvvBQAnnftWS@DKfhmcrQ!*z',
  api: {
    "ull_": "https://qa.rutayasistenciaclub.cl/app/views/mw_autoinspeccion/",
    "uss_": 'U2FsdGVkX194OQ6Fhb7bFqabdNcyPXViWJLrJ8mBs0k=',
    "pss_": 'U2FsdGVkX19QcQIhfqibUohxb0wgk2k3cztQWMyRfPI=',
  },
  production: false,
  gtag_mode: true,
  contacto : {
    wsp: "+56950075507",
    telefonocall: "+56223850180",
    texto : "Hola! Necesito ayuda"
  },
  // codigo para desarrollo
  gtagcode: 'GTM-WTG2GL9',
  apiurl: 'https://qa.rutayasistenciaclub.cl/app/views/mw_autoinspeccion/',
  flag_fala: true
};

// export const environment = {
//   _ssp: 'M#0AygZi36C9*EcPxNATUsB^V9WlZmUQJ^FrrJ$tUvvBQAnnftWS@DKfhmcrQ!*z',
//   api: {
//     //"ull_": "https://ws.rutayasistenciaclub.cl/app/views/mw_autoinspeccion/",  // servidor nuevo
//     "ull_": "https://ws.rutayasistenciaclub.cl/app/views/mw_autoinspeccion/", // parinacota
//     "uss_": 'U2FsdGVkX194OQ6Fhb7bFqabdNcyPXViWJLrJ8mBs0k=',
//     "pss_": 'U2FsdGVkX19QcQIhfqibUohxb0wgk2k3cztQWMyRfPI=',
//   },
//   // ssp: "",
//   // api : {
//   //   "url" : "https://proxyinspecciones.clubautomotriz.cl/webapp_autoinspeccion/bridge/",
//   //   "user" : "autoinspeccion",
//   //   "pass" : "9ba59abbe56e0",
//   // },


//   contacto : {
//     wsp: "+56950104970",
//     telefonocall: "+56223850180",
//     texto : "Hola! Necesito ayuda"
//   },

//   production: true,
//   apiurl: "https://ws.rutayasistenciaclub.cl/app/views/mw_autoinspeccion/", // parinacota
//   gtag_mode: true,
//   // código para produccion
//   gtagcode: 'GTM-TGJSRF9',
//   flag_fala: true
// };